import { tickerItems } from "@/mocks/gossip";

export default function TopBar() {
  const doubled = [...tickerItems, ...tickerItems];

  return (
    <div className="relative overflow-hidden border-b border-stone-200 bg-[#241b13] text-stone-200">
      <div className="mx-auto flex max-w-[1400px] items-center gap-3 px-4 py-2 md:px-6">
        <span className="flex shrink-0 items-center gap-1.5 rounded-full bg-brand-500 px-2.5 py-0.5 text-[11px] font-semibold tracking-wide text-white">
          <span className="live-dot inline-block h-1.5 w-1.5 rounded-full bg-white" />
          实时速递
        </span>
        <div className="relative flex-1 overflow-hidden">
          <div className="ticker-track flex w-max whitespace-nowrap">
            {doubled.map((item, i) => (
              <a
                key={i}
                href="#hero"
                onClick={(e) => {
                  e.preventDefault();
                  document
                    .getElementById("hero")
                    ?.scrollIntoView({ behavior: "smooth" });
                }}
                className="mr-10 inline-flex items-center gap-2 text-[13px] text-stone-300 hover:text-white"
              >
                <span className="text-brand-400">▲</span>
                {item}
              </a>
            ))}
          </div>
        </div>
        <span className="hidden shrink-0 items-center gap-1 text-[12px] text-stone-400 sm:flex">
          <i className="ri-timer-flash-line text-brand-400" />
          刷新越快 · 料越足
        </span>
      </div>
    </div>
  );
}